import React, { useEffect, useMemo } from "react";
import { useTable } from "react-table";
import { Table } from "react-bootstrap";
import { SetObserver } from "../../libs/Observer";

const toCurrency = (number) => {
  return parseFloat(number).toFixed(2);
};

const TransactionLineRow = (props) => {
  const columns = useMemo(
    () => [
      {
        Header: "GL Account",
        accessor: "glAccount",
      },
      {
        Header: "Class",
        accessor: "class",
      },
      {
        Header: "Department",
        accessor: "department",
      },
      {
        Header: "Memo",
        accessor: "memo",
      },
      {
        id: "Debit",
        accessor: "debit",
        Header: () => {
          return <div className="right">Debit</div>;
        },
        Cell: (props) => (
          <div className="right">{toCurrency(props.value)} </div>
        ),
      },
      {
        id: "Credit",
        accessor: "credit",
        Header: () => {
          return <div className="right">Credit</div>;
        },
        Cell: (props) => (
          <div className="right">{toCurrency(props.value)} </div>
        ),
      },
      {
        Header: "Tax Detail",
        accessor: "taxDetail",
      },
      {
        accessor: "taxAmount",
        Header: () => {
          return <div className="right">Tax Amount</div>;
        },
        Cell: (props) => (
          <div className="right">{toCurrency(props.value)} </div>
        ),
      },
      {
        id: "Total Debit",
        accessor: "totalDebit",
        Header: () => {
          return <div className="right">Total Debit</div>;
        },
        Cell: (props) => (
          <div className="right">{toCurrency(props.value)} </div>
        ),
      },
      {
        id: "Total Credit",
        accessor: "totalCredit",
        Header: () => {
          return <div className="right">Total Credit</div>;
        },
        Cell: (props) => (
          <div className="right">{toCurrency(props.value)} </div>
        ),
      },
    ],

    []
  );

  const data = useMemo(() => props.Content, [props.Content]);

  useEffect(() => {
    SetObserver();
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    rows,
  } = useTable({
    columns,
    data,
    initialState: { pageIndex: 0 },
  });

  if (data.length <= 0) {
    return <p className="center">No Receipt List Line Data to display.</p>;
  } else
    return (
      <div className="TransactionLineRow">
        <div className="react-table">
          <Table hover size="sm" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup, i) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody id={"TransactionLineRow"} {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    );
};

export default TransactionLineRow;
